<template>
  <div class="page-wrapper reg-link-wrap">
    <breadcrumb :items="breadcrumbItems" />
    <div class="page-title emp-grp-title">
      <div class="grp-title">
        <h1 class="mb-3">Email Log</h1>
      </div>
    </div>
    <div class="bg-white">
      <div class="d-flex flex-wrap search-options gap-3 mb-3">
        <div class="">
          <div class="d-flex align-items-stretch quick-filter-wrap">
            <!-- Dropdown Label -->
            <div class="label-dropdown position-relative">
              <button class="text-capitalize" type="button">Email</button>
            </div>

            <!-- Input with Search Icon -->
            <div class="dropdown-input-wrap position-relative flex-grow-1">
              <input
                type="text"
                class="dropdown-input w-100 pe-5"
                placeholder="Search Email"
                v-model="filters.email"
                @keyup.enter="triggerSearch"
              />
              <i
                class="fa fa-search position-absolute text-muted"
                style="
                  top: 50%;
                  right: 1rem;
                  transform: translateY(-50%);
                  pointer-events: none;
                "
              ></i>
            </div>
          </div>
        </div>
        <div class="">
          <QuickDropdownFilter
            :modelValue="selectedStatus"
            @update:modelValue="onStatusChange"
            label="Select Mail Status"
            :options="[
              'All',
              'Queued',
              'Sent',
              'Invalid',
              'Delivered',
              'Opened',
              'Bounced',
              // 'Blog',
              // 'Unsubscribed',
            ]"
            class="quick-dropdown-filter"
            v-model="selectedStatus"
          />
        </div>
        <div class="d-flex align-items-center gap-2 quick-filter-wrap">
          <label class="">
            <strong> Sent Date </strong>
          </label>
          <input
            type="date"
            class="quick-dropdown-filter p-2 h-100"
            v-model="send_date"
            @change="onDateChange"
          />
        </div>
        <div class="d-flex align-items-center gap-2 quick-filter-wrap">
          <button
            type="button"
            class="quick-dropdown-filter clear-filter p-2 h-100"
            @click="clearFilters()"
          >
            Clear Filters
          </button>
        </div>
      </div>
      <div class="clientsData-wrap">
        <div class="top-pagination">
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Recipients</th>
                <th>Email Details</th>
                <th>Sent Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="emailLogs.length === 0">
                <td colspan="5" class="text-center">No email logs found</td>
              </tr>
              <!-- Example Row with Modal Trigger -->
              <tr v-for="email in emailLogs" :key="email.id">
                <td>{{ email.id }}</td>
                <td>
                  To : <span class="recipient">{{ email.to_email }}</span
                  ><br />
                  <span
                    :class="[
                      'status',
                      email.status.toLowerCase() === 'invalid'
                        ? 'failed'
                        : email.status.toLowerCase(),
                    ]"
                  >
                    {{ email.status }}
                  </span>
                </td>
                <td>
                  <b>Subject:</b> {{ email.subject }} <br />
                  <!-- <b>Application:</b> Corenroll <br />
                  <b>Subcategory:</b> DASHBOARD_MAIL <br />
                  <b>Email config:</b> OTP_SEND_EMAIL -->
                </td>
                <td>{{ email.created_at }}</td>
                <td class="actions">
                  <div class="d-flex gap-2">
                    <div class="mr-2">
                      <b-button
                        variant="link"
                        class="p-0 text-decoration-none"
                        @click="openViewDetailsModal(email.id)"
                      >
                        <i class="fa fa-eye"></i>
                      </b-button>
                    </div>
                    <div>
                      <b-button
                        variant="link"
                        class="p-0 text-decoration-none"
                        @click="openForwardEmailModal(email.id)"
                      >
                        <i class="fa fa-share"></i>
                      </b-button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination :rows.sync="rows" :filters="filters" />
      </div>
    </div>

    <!-- Pass the `showViewDetailsModal` data property to the ViewDetails component -->
    <!-- The .sync modifier will listen for 'update:show' from child and update showViewDetailsModal -->
    <ViewDetails :show.sync="showViewDetailsModal" :emailId="propData" />
    <ForwardEmail
      :show.sync="showForwardEmailModal"
      :emailId="forwardPropData"
    />
  </div>
</template>

<script>
import QuickDropdownFilter from "../../components/ui/QuickDropdownFilter.vue";
import ViewDetails from "./ViewDetails.vue";
import ForwardEmail from "./ForwardEmail.vue";
import axios from "axios";
export default {
  name: "RegistrationLinkLog",
  components: {
    QuickDropdownFilter,
    ViewDetails,
    ForwardEmail,
  },
  computed: {
  breadcrumbItems() {
    // return this.filters.type == 'group'
    if(this.filters.type=="G"){
      return this.breadcrumbItemsGroup
    }else{
      return this.breadcrumbItemsRep
    }
  }
},
  data() {
    return {
      breadcrumbItemsRep: [
        { title: "Downline Reps", path: { name: "DownlineRepList" }, active:true },
        {
          title: "Email Logs",
          path: { name: "RegistrationonLinkLog" },
          active: true,
        },
      ],
      breadcrumbItemsGroup: [
        { title: "Employer & Groups", path: { name: "EmployerGroupList" }, active:true },
        {
          title: "Email Logs",
          path: { name: "RegistrationonLinkLog" },
          active: true,
        },
      ],
      inputValue: "", // For your search input
      selectedStatus: null, // For your dropdown filter
      showViewDetailsModal: false, // This will control the ViewDetails modal visibility
      showForwardEmailModal: false,
      emailLogs: [],
      pagination: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 0,
        from: 0,
        to: 0,
        first_page_url: "",
        last_page_url: "",
        next_page_url: "",
        prev_page_url: "",
      },
      filters: {
        status: null,
        email: null,
        send_date: null,
        type: "",
      },
      propData: null, // To pass ID to ViewDetails modal
      rows: [],
      filterQuery: {},
      forwardPropData: null,
      send_date: "",
    };
  },
  methods: {
    clearFilters() {
      this.email = "";
      this.send_date = "";
      this.selectedStatus = "All";
      this.filters = {
        status: null,
        email: null,
        send_date: null,
        type:this.filters.type
      };
      this.getEmailLogData(this.filters);
    },
    onStatusChange(value) {
      if (value === "All") {
        value = "";
      }
      this.selectedStatus = value;
      this.filters.status = value;
      this.getEmailLogData(this.filters);
    },
    triggerSearch() {
      this.getEmailLogData(this.filters);
    },
    onDateChange() {
      this.filters.send_date = this.send_date;
      this.getEmailLogData(this.filters);
    },
    openViewDetailsModal(id) {
      this.propData = id; // Pass the ID to the modal component
      this.showViewDetailsModal = true;
    },
    openForwardEmailModal(id) {
      this.forwardPropData = id;
      this.showForwardEmailModal = true;
    },

    async getEmailLogData(filters = {}) {
      let url = `v2/get-registration-email-logs`;
      let loader = this.$loading.show();

      try {
        const response = await axios.get(url, { params: filters });
        this.rows = response.data;
        this.emailLogs = response.data.records;
      } catch (err) {
        this.$notify(err.response.data.message, "error");
      } finally {
        loader.hide();
      }
    },
  },

  mounted() {
    // this.getEmailLogData();
  },
  watch: {
    rows(newVal) {
      this.emailLogs = newVal.records || [];
    },
    "$route.params.type": {
      handler(newVal) {
        if(newVal=="group"){
        this.filters.type = "G";
        this.getEmailLogData(this.filters);
        }
        else{
          this.filters.type="A";
          this.getEmailLogData(this.filters);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style>
/* Your existing styles */
.bg-white {
  background: #fff;
  padding: 1.5rem;
  border-radius: 6px;
}
.clientsData-wrap table tr th {
  background: #fafbfd !important;
  padding: 1rem;
  border: 1px solid #d7e1ea;
  border-bottom: 0;
}
.clientsData-wrap .table tbody tr {
  line-height: 26px;
}
.clientsData-wrap .table strong,
.clientsData-wrap .table thead th {
  color: #254050;
  font-weight: bold;
}
.clientsData-wrap .table tbody tr td {
  padding: 1rem;
  border: 1px solid #d7e1ea;
}
.advance-btn {
  font-weight: 500;
  font-size: 14px;
  color: #344054;
  border: solid 1px #ced4da;
  border-radius: 6px;
  background-color: white;
  padding: 0.75rem;
}
.status {
  color: #fff;
  border-radius: 4px;
  padding: 0.2rem 0.8rem;
  font-size: 12px;
}
.delivered {
  background: rgb(2, 102, 2);
}
.sent {
  background: rgb(0, 102, 128);
}
.failed {
  background: red;
}
.pending {
  background: gray;
}
.bounced {
  background: orange;
}
.opened {
  background: rgb(173, 150, 1);
}
.quick-filter-wrap {
  max-height: 50px;
}
.quick-filter-wrap .label-dropdown {
  border: none;
  border-radius: 0;
}
.quick-filter-wrap .label-dropdown button {
  border: none;
  border-radius: 6px 0 0 6px;
  background: #f3f3f3;
  color: #254050;
  padding: 0.75rem 1rem;
  font-size: 14px;
  font-weight: 600;
}
.label-dropdown button:hover,
.label-dropdown button:active {
  border: none !important;
}
.quick-filter-wrap .dropdown-menu {
  padding: 0;
}
.quick-filter-wrap .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #717171;
  padding: 0.5rem 0.8rem;
}
.quick-filter-wrap .dropdown-menu li:first-child {
  border-bottom: solid 1px #ced4da;
}
.quick-filter-wrap .dropdown-menu .selected-option a {
  color: #03c6ec;
  font-weight: 400;
}
.quick-filter-wrap .dropdown-input {
  border: none;
  border-radius: 0 6px 6px 0;
  background-color: #fafbfd;
  font-size: 14px;
  padding: 0.75rem 1rem;

  height: 100%;
}
.quick-filter-wrap .dropdown-input:focus {
  border: none;
}
.reg-link-wrap
  .clientsData-wrap
  > .table-responsive
  > .table
  > tbody
  td:nth-child(5) {
  width: auto;
  color: #03c6ec;
}
.btn-link {
  color: #03c6ec !important;
}
.btn-link:active,
.btn-link:focus {
  box-shadow: none !important;
}
.reg-link-wrap label {
  color: #254050;
  font-size: 14px;
  font-weight: 600;
}
.clear-filter {
  background: #eb2121;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
}
</style>
